module.exports = __webpack_public_path__ + "img/6_no.8dcfbfe0.svg";